



































import { Component, Mixins } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import TimeCardForm from '@/components/kintai/organisms/TimeCardForm.vue'
import { IFormStore } from '@/store/types'
import { kintaiInputStore } from '@/store/form/KintaiInputFormStore'
import { ApiGeneralSinglePayload } from '@/tcw/api/types'

@Component({
  components: {
    TcwLayoutBasicTemplate,
    TimeCardForm
  }
})
export default class TimeCardPage extends Mixins(BasePage) {
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return kintaiInputStore
  }
  private recordKaishiTime() {
    const formEle = this.$refs.form as any
    if (formEle && typeof formEle.saveKaishiTime === 'function') {
      formEle.saveKaishiTime()
    }
  }
  private recordShuryoTime() {
    const formEle = this.$refs.form as any
    if (formEle && typeof formEle.saveShuryoTime === 'function') {
      formEle.saveShuryoTime()
    }
  }
  /**
   * 勤怠入力画面遷移後にも勤怠データを再取得するため、一旦storeModuleをクリアする
   */
  private async beforeRouteLeave(to: any, from: any, next: any) {
    this.storeModule.clear()
    next()
  }

}
